import { createContext } from "react";

const CustomDropdownContext = createContext();

export default CustomDropdownContext;
